export default {
    STANDARD: 'STANDARD',
    SUPERSET: 'SUPERSET',
    ALTERNATING: 'ALTERNATING',
    OFF_PROGRAM: 'OFF_PROGRAM',
};
